import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FollowCreativeSetEffects } from './follow-creativeset.effects';
import { FOLLOW_CREATIVESET_FEATURE_KEY, reducer } from './follow-creativeset.reducer';

export function provideFollowCreativeSetStore(): EnvironmentProviders {
    return importProvidersFrom(
        StoreModule.forFeature(FOLLOW_CREATIVESET_FEATURE_KEY, reducer),
        EffectsModule.forFeature(FollowCreativeSetEffects)
    );
}
